import HrUpgradePage from './components/HrUpgradePage';

export default HrUpgradePage;
